const config = {
  ASSETS_PATH: (window as any).runtimeConfig.ASSETS_PATH,
  API_URL: (window as any).runtimeConfig.API_URL,
  STATIC_DATA_URL: (window as any).runtimeConfig.STATIC_DATA_URL,
  STATIC_DATA_FOLDER: (window as any).runtimeConfig.STATIC_DATA_FOLDER,
  CLOUD_STORAGE_URL: (window as any).runtimeConfig.CLOUD_STORAGE_URL,
  CLOUD_STORAGE_BUCKET: (window as any).runtimeConfig.CLOUD_STORAGE_BUCKET,
  PUBLISHER_ID: (window as any).runtimeConfig.PUBLISHER_ID,
  GA_TRACKING_CODE: (window as any).runtimeConfig.GA_TRACKING_CODE,
};

export default config;
